import { serializeThrift, deserializeThrift } from "../thrift/ThriftFormatter";
import { UserRecoveryKeyMetadata } from "../thrift/UserRecoveryKeyMetadata_types";

export const serializeUserRecoveryKeyFile = (recoveryKey, recoveryKeyId) => {
  const metadata = new UserRecoveryKeyMetadata({ recoveryKey, recoveryKeyId });
  return serializeThrift(metadata);
};

export const deserializeUserRecoveryKeyFile = (content) => {
  const metadata = deserializeThrift(
    content.trim(),
    new UserRecoveryKeyMetadata(),
  );
  return {
    recoveryKey: metadata.recoveryKey,
    recoveryKeyId: Number(metadata.recoveryKeyId),
  };
};
